// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62913f11","453":"5a769df8","455":"ff123ba8","977":"b3b7ca60"}[chunkId] + ".chunk.js";
};